import { ArrowLeftRight } from "lucide-react";
import { Button } from "../ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { TOP_LANGUAGES, ALL_LANGUAGES } from "../../data/languages";

/**
 * Language picker row + quick-set pills for the patient language.
 */
export default function ConversationLanguageBar({
  therapistLang,
  patientLang,
  onTherapistChange,
  onPatientChange,
  onSwap,
}) {
  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-[1fr_auto_1fr] items-end gap-4">
        <div>
          <p className="text-sm uppercase tracking-[0.2em] text-zinc-500 mb-2">Therapist speaks</p>
          <Select value={therapistLang} onValueChange={onTherapistChange}>
            <SelectTrigger className="h-12 text-base" data-testid="conv-therapist-lang">
              <SelectValue />
            </SelectTrigger>
            <SelectContent className="max-h-80">
              {ALL_LANGUAGES.map((l) => <SelectItem key={l} value={l}>{l}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
        <Button variant="outline" onClick={onSwap} className="h-12 w-12 p-0" data-testid="conv-swap" title="Swap languages">
          <ArrowLeftRight className="w-4 h-4" />
        </Button>
        <div>
          <p className="text-sm uppercase tracking-[0.2em] text-zinc-500 mb-2">Patient speaks</p>
          <Select value={patientLang} onValueChange={onPatientChange}>
            <SelectTrigger className="h-12 text-base" data-testid="conv-patient-lang">
              <SelectValue />
            </SelectTrigger>
            <SelectContent className="max-h-80">
              {ALL_LANGUAGES.map((l) => <SelectItem key={l} value={l}>{l}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
      </div>

      <div>
        <p className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-2">Quick set patient language</p>
        <div className="flex flex-wrap gap-2">
          {TOP_LANGUAGES.map((l) => (
            <button
              key={l.name}
              onClick={() => onPatientChange(l.name)}
              className={`px-3 h-9 rounded-lg border text-xs font-medium transition-colors ${
                patientLang === l.name
                  ? "bg-zinc-900 text-white border-zinc-900"
                  : "bg-white text-zinc-700 border-zinc-200 hover:bg-zinc-50"
              }`}
              data-testid={`conv-quick-${l.name}`}
            >
              {l.name}
            </button>
          ))}
        </div>
      </div>
    </>
  );
}
